module.exports = __webpack_public_path__ + "img/class2.5ff3f820.png";